import { useState } from 'react';

export const useUpdate = () => {
  const [, setFlag] = useState({});
  const update = () => {
    setFlag({});
  };

  return [update];
};
